<template>
    <div class="content-line" v-loading="isUploading">
        <Card title="营业数据导入">
            <div class="content-line content-padding">
                <label>数据文件：</label>
                <el-upload
                    class="upload-demo"
                    ref="upload"
                    :action="fileUploadUrl"
                    :auto-upload="false"
                    :data="uploadData"
                    :limit="1"
                    :on-success="uploadSuccess"
                    :on-error="uploadError"
                    :headers="uploadHeaders"
                >
                    <el-button size="small" type="primary"> 选择文件 </el-button>
                    <template #tip>
                        <a href="/operate.xlsx" target="_blank" download="operate.xlsx"> 下载模版 </a>
                        <a href="/operateproduct.xlsx" target="_blank" download="operate.xlsx"> 下载商品子类模版 </a>
                    </template>
                </el-upload>
            </div>
            <div class="content-line content-padding">
                <el-button type="primary" @click="uploadStaions"> 确定 </el-button>
            </div>
        </Card>
    </div>
</template>
<script>
export default {
    name: "import",
    components: {},
    data() {
        return {
            isUploading: false,
            fileUploadUrl: window.VUE_APP_BASE_API + "/Ops/ImportOperate",
            uploadHeaders: {
                Authorization: "Bearer " + this.$auth.getToken(),
            },
            fileList: [],
            defaultOrg: {},
        };
    },
    created() {},
    methods: {
        uploadStaions() {
            this.isUploading = true;
            this.$refs.upload.submit();
        },
        uploadSuccess(response, file, fileList) {
            this.isUploading = false;
            if (response.Code == 0) {
                this.$success("上传成功！");
            } else {
                this.$error(response.Code + "");
            }
            this.$refs.upload.clearFiles();
        },
        uploadError(err, file, fileList) {
            this.isUploading = false;
            console.log(err);
        },
    },
};
</script>
